// ============================================================
// Rabatt-Bestaetigung als Streifen — 1InstaPhone Shop-Theme
//
// WAS ES TUT: Wer ueber einen Rabattlink kommt
// (https://1instaphone.com/discount/CODE?redirect=...), sieht oben
// auf der Seite kurz einen Streifen: "Dein Rabattcode CODE ist
// aktiviert - wird an der Kasse automatisch abgezogen."
// Nach 6 Sekunden blendet er sich von selbst wieder aus. Einmal je
// Sitzung, damit er beim Weiterklicken nicht staendig neu aufpoppt.
// Gilt fuer JEDEN per Link aktivierten Code, nicht nur AMED30.
//
// WIE ES ERKENNT, DASS EIN CODE LIEGT: Shopify setzt beim Aufruf von
// /discount/CODE das Cookie `discount_code`. Das Cookie ist NICHT
// HttpOnly (am 25.09.2026 am Antwort-Header belegt), also mit
// document.cookie lesbar. Ohne Cookie passiert gar nichts.
//
// WAS ES NICHT TUT: Es fasst die Rabatt-Mechanik nicht an, rechnet
// nichts und nennt keine Prozentzahl. Grund: ab drei Huellen greift
// nicht der Code, sondern die guenstigere Dauer-Aktion
// "2 kaufen, die dritte gratis". Eine Prozentzahl im Streifen waere
// dort falsch. Der Streifen sagt nur, DASS der Code liegt.
//
// WAS ES NICHT PRUEFEN KANN: ob der Code gueltig ist. Shopify legt
// jeden Code aus dem Link ins Cookie, auch einen erfundenen oder
// abgelaufenen (security-sven, 25.09.2026). Deshalb gilt betrieblich:
// nie einen toten Code in einen Link setzen.
//
// EINBAU: Diese Datei liegt im Theme als assets/bf-rabatt-streifen.js und
// wird in layout/theme.liquid vor dem schliessenden body-Tag geladen mit:
//
//   <script src="{{ 'bf-rabatt-streifen.js' | asset_url }}" defer>
//
// Kein Google-Font noetig, der Streifen erbt die Theme-Schrift.
// ============================================================

(function () {
  'use strict';

  var ANZEIGEDAUER_MS = 6000;      // wie lange der Streifen steht
  var SITZUNGS_SCHLUESSEL = 'bf_rabatt_streifen_gezeigt';

  function codeAusCookie() {
    var treffer = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    if (!treffer) return null;
    try {
      var wert = decodeURIComponent(treffer[1]).trim();
      // Nur plausible Codes: Buchstaben, Ziffern, Bindestrich, Unterstrich.
      return /^[A-Za-z0-9_-]{2,40}$/.test(wert) ? wert : null;
    } catch (e) {
      return null;
    }
  }

  function schonGezeigt() {
    try { return sessionStorage.getItem(SITZUNGS_SCHLUESSEL) === '1'; }
    catch (e) { return false; }   // privates Fenster: dann eben jedes Mal
  }

  function alsGezeigtMerken() {
    try { sessionStorage.setItem(SITZUNGS_SCHLUESSEL, '1'); } catch (e) {}
  }

  function bauen(code) {
    var leiste = document.createElement('div');
    leiste.id = 'bf-rabatt-streifen';
    leiste.setAttribute('role', 'status');
    leiste.setAttribute('aria-live', 'polite');
    leiste.innerHTML =
      '<div class="bf-rs-inhalt">' +
        '<span class="bf-rs-haken" aria-hidden="true">' +
          '<svg viewBox="0 0 20 20" width="17" height="17">' +
          '<path d="M4 10.5l4 4 8-9" fill="none" stroke="currentColor" ' +
          'stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</span>' +
        '<span class="bf-rs-text">Dein Rabattcode <b class="bf-rs-code"></b> ist aktiviert' +
          '<span class="bf-rs-zusatz"> &ndash; wird an der Kasse automatisch abgezogen.</span>' +
        '</span>' +
        '<button type="button" class="bf-rs-zu" aria-label="Hinweis schliessen">&times;</button>' +
      '</div>';

    // Der Code wird als Text gesetzt, nicht in den HTML-String geklebt. Die
    // Filterung oben reicht zwar, aber so haengt die Sicherheit nicht daran,
    // falls spaeter jemand Codes mit Punkt oder Leerzeichen zulaesst.
    leiste.querySelector('.bf-rs-code').textContent = code;

    var stil = document.createElement('style');
    stil.textContent = [
      '#bf-rabatt-streifen{position:fixed;top:0;left:0;right:0;z-index:2147483000;',
      'background:#1a7a2c;color:#fff;font-size:15px;line-height:1.35;',
      'font-family:inherit;box-shadow:0 2px 10px rgba(0,0,0,.18);',
      'transform:translateY(-100%);transition:transform .35s ease;}',
      '#bf-rabatt-streifen.bf-rs-an{transform:translateY(0);}',
      '.bf-rs-inhalt{max-width:1100px;margin:0 auto;padding:11px 44px 11px 16px;',
      'display:flex;align-items:center;gap:9px;position:relative;}',
      '.bf-rs-haken{display:flex;align-items:center;flex:0 0 auto;}',
      '.bf-rs-text{flex:1 1 auto;}',
      '.bf-rs-text b{font-weight:700;letter-spacing:.02em;}',
      '.bf-rs-zu{position:absolute;right:8px;top:50%;transform:translateY(-50%);',
      'background:none;border:0;color:#fff;font-size:24px;line-height:1;',
      'padding:2px 8px;cursor:pointer;opacity:.75;}',
      '.bf-rs-zu:hover{opacity:1;}',
      '@media (max-width:600px){#bf-rabatt-streifen{font-size:13.5px;}',
      '.bf-rs-inhalt{padding:9px 40px 9px 12px;}',
      '.bf-rs-zusatz{display:block;}}',
      '@media (prefers-reduced-motion:reduce){#bf-rabatt-streifen{transition:none;}}'
    ].join('');

    document.head.appendChild(stil);
    document.body.appendChild(leiste);

    var weg = function () {
      leiste.classList.remove('bf-rs-an');
      setTimeout(function () {
        if (leiste.parentNode) leiste.parentNode.removeChild(leiste);
      }, 400);
    };

    leiste.querySelector('.bf-rs-zu').addEventListener('click', weg);
    // Einblenden bewusst ueber setTimeout, nicht ueber requestAnimationFrame:
    // rAF feuert nicht in jedem Umfeld (Hintergrund-Tab, Vorschau-Render), und
    // dann bliebe der Streifen dauerhaft eingeklappt stehen.
    setTimeout(function () { leiste.classList.add('bf-rs-an'); }, 30);
    setTimeout(weg, ANZEIGEDAUER_MS);
  }

  function start() {
    if (schonGezeigt()) return;
    var code = codeAusCookie();
    if (!code) return;
    alsGezeigtMerken();
    bauen(code);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
